import {requiredValidator} from '../../shared/validators';
import type {Validator} from 'svelte-forms';
import {isDefined} from '../../../../utils/custom-utils';
import type {ValueEditorValidations} from '../../../kp-value-editor/types';

export function validatorFactory(validations: ValueEditorValidations): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator());
    }

    return validators;
}